import { createFileRoute } from '@tanstack/react-router';
import { useIntl } from 'react-intl';
import { z } from 'zod';
import { AcademicStage } from '@_/constants';
import { SeoTags } from '#src/components/SeoTags/index.ts';
import { venueListFilterSchema } from '#src/components/VenueListFilter/index.ts';
import { SchoolsPage } from '#src/pages/SchoolsPage/index.ts';

export const Route = createFileRoute('/{-$locale}/schools')({
  component: RouteComponent,
  validateSearch: z.object({
    ...venueListFilterSchema.shape,
    type: z.enum(AcademicStage).default(AcademicStage.PrePrimary).catch(AcademicStage.PrePrimary)
  })
});

function RouteComponent() {
  const searchParams = Route.useSearch();
  const intl = useIntl();

  let title: string | undefined;

  if (searchParams.type === AcademicStage.PrePrimary) {
    title = intl.formatMessage({
      id: 'head.kindergartens-page',
      defaultMessage: 'Kindergartens, Nurseries, and Playgroups in Hong Kong'
    });
  } else if (searchParams.type === AcademicStage.Primary) {
    title = intl.formatMessage({
      id: 'head.primary-schools-page',
      defaultMessage: 'Primary Schools in Hong Kong'
    });
  } else if (searchParams.type === AcademicStage.Secondary) {
    title = intl.formatMessage({
      id: 'head.secondary-schools-page',
      defaultMessage: 'Secondary Schools in Hong Kong'
    });
  } else if (searchParams.type === AcademicStage.Tertiary) {
    title = intl.formatMessage({
      id: 'head.post-secondary-schools-page',
      defaultMessage: 'Universities, Colleges, and Vocational Schools in Hong Kong'
    });
  }

  return (
    <>
      <SeoTags title={title} useCurrentCanonicalPath={!searchParams.countryZoneCodes?.length} />

      <SchoolsPage key={searchParams.type} />
    </>
  );
}
